export function createEmptyBatchUserRow() {
  return {
    username: '',
    name: '',
    email: '',
    password: '',
    role: 'user',
  };
}

export function buildAddedBatchUserRows(userList) {
  return [...(userList || []), createEmptyBatchUserRow()];
}

export function buildRemovedBatchUserRows(userList, index, minLength = 1) {
  const list = Array.isArray(userList) ? userList : [];
  if (list.length <= minLength) return list;
  return list.filter((_, i) => i !== index);
}

export function buildUpdatedBatchUserRows(userList, index, field, value) {
  const next = [...(userList || [])];
  const current = { ...(next[index] || createEmptyBatchUserRow()) };
  current[field] = value;
  next[index] = current;
  return next;
}

export function buildBatchCreateValidationResult(userList) {
  const errors = [];
  const usersToCreate = [];

  (userList || []).forEach((user, index) => {
    const isEmpty = !user.username && !user.name && !user.email && !user.password;
    if (isEmpty) return;

    if (!user.username || !user.name || !user.email || !user.password) {
      errors.push(`第 ${index + 1} 行：请填写必填项（用户名、姓名、邮箱、密码）`);
      return;
    }

    usersToCreate.push(user);
  });

  return { errors, usersToCreate };
}

/** 批量创建行 → POST /api/users 正文（不含审计组/审计角色，权限固定按用户配置） */
export function mapBatchRowToCreateApiPayload(row) {
  return {
    username: String(row?.username || '').trim(),
    password: row?.password,
    name: (row?.name && String(row.name).trim()) ? String(row.name).trim() : null,
    email: (row?.email && String(row.email).trim()) ? String(row.email).trim() : null,
    role: 'user',
    permissionBasis: 'user',
  };
}

export function buildBatchCreateErrorText(errors, maxLines = 5) {
  const list = Array.isArray(errors) ? errors : [];
  return list.slice(0, maxLines).join('\n') + (list.length > maxLines ? '\n...' : '');
}
